export default {
    inquiryList: [],
    inquiryListCount: 0,
    inquiry: {}
}